import { render, staticRenderFns } from "./LeaveBalanceList.vue?vue&type=template&id=55ab5c15"
import script from "../../controllers/leave_balance/leave-balance-list.js?vue&type=script&lang=js&external"
export * from "../../controllers/leave_balance/leave-balance-list.js?vue&type=script&lang=js&external"
import style0 from "./LeaveBalanceList.vue?vue&type=style&index=0&id=55ab5c15&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports